(() => {
  'use strict';
  if (window.sbcPerformanceShowroom) return;
  window.sbcPerformanceShowroom = true;

  function init(root) {
    root.querySelectorAll('[data-sbc-product]').forEach((product) => {
      if (product.dataset.sbcReady) return;
      product.dataset.sbcReady = 'true';
      const variants = JSON.parse(product.querySelector('[data-sbc-variants]').textContent);
      const selectors = [...product.querySelectorAll('[data-sbc-option]')];
      const price = product.querySelector('[data-sbc-price]');
      const status = product.querySelector('[data-sbc-status]');
      const shop = product.querySelector('[data-sbc-shop]');
      const initialUrl = shop.getAttribute('href').split('?')[0];

      function update() {
        const variant = variants.find((item) => item.options.every((value, index) => !selectors[index] || selectors[index].value === value));
        price.textContent = variant ? variant.price : '—';
        status.textContent = !variant ? 'This combination is not offered' : variant.available ? 'Available to order' : 'Currently unavailable';
        shop.href = variant ? variant.url : initialUrl;
        shop.firstChild.textContent = variant ? 'View this setup ' : 'Explore available setups ';
      }
      selectors.forEach((select) => select.addEventListener('change', update));
      product.querySelector('[data-sbc-configuration]').hidden = false;

      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
